export type FeatureFlags = {
  screenshots: boolean;
  trading: boolean;
  gitStateViewer: boolean;
  worldMap: boolean;
};

const env = (import.meta as any).env || {};

const parseBool = (v: any, def = false) => {
  if (v === true || v === false) return v;
  if (typeof v === 'string') return ['1', 'true', 'on', 'yes', 'y'].includes(v.toLowerCase());
  return def;
};

export const featureFlags: FeatureFlags = {
  screenshots: parseBool(env.VITE_FEATURE_SCREENSHOTS, false),
  trading: parseBool(env.VITE_FEATURE_TRADING, false),
  gitStateViewer: parseBool(env.VITE_FEATURE_GIT_STATE, false),
  worldMap: parseBool(env.VITE_FEATURE_WORLD_MAP, false),
};

export const isFeatureEnabled = (key: keyof FeatureFlags) => featureFlags[key];
